var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
// - Import react components
import React, { Component } from 'react';
import CircularProgress from '@material-ui/core/CircularProgress';
import red from '@material-ui/core/colors/red';
import Grid from '@material-ui/core/Grid/Grid';
import { Typography } from '@material-ui/core';
// - Import app components
// - Create MasterLoading component class
var MasterLoadingComponent = /** @class */ (function (_super) {
    __extends(MasterLoadingComponent, _super);
    // Constructor
    function MasterLoadingComponent(props) {
        return _super.call(this, props) || this;
        // Binding functions to `this`
    }
    MasterLoadingComponent.prototype.loadProgress = function () {
        var _a = this.props, error = _a.error, timedOut = _a.timedOut, pastDelay = _a.pastDelay;
        if (error) {
            return (React.createElement(Grid, { container: true },
                React.createElement(Grid, { item: true },
                    React.createElement(CircularProgress, { style: { color: red[500] }, size: 50 })),
                React.createElement(Grid, { item: true, style: { zIndex: 1 } },
                    React.createElement(Typography
                    // variant='title'
                    , { 
                        // variant='title'
                        color: 'primary', style: { marginLeft: '15px' } }, "Unexpected Error Happened ..."))));
        }
        else if (timedOut) {
            return (React.createElement(Grid, { container: true },
                React.createElement(Grid, { item: true },
                    React.createElement(CircularProgress, { style: { color: red[500] }, size: 50 })),
                React.createElement(Grid, { item: true, style: { zIndex: 1 } },
                    React.createElement(Typography
                    // variant='title' 
                    , { 
                        // variant='title' 
                        color: 'primary', style: { marginLeft: '15px' } }, "It takes a long time ..."))));
        }
        else if (pastDelay) {
            return (React.createElement(Grid, { container: true },
                React.createElement(Grid, { item: true },
                    React.createElement(CircularProgress, { size: 50 })),
                React.createElement(Grid, { item: true, style: { zIndex: 1 } },
                    React.createElement(Typography
                    // variant='title' 
                    , { 
                        // variant='title' 
                        color: 'primary', style: { marginLeft: '15px' } }, "Loading..."))));
        }
        else {
            return (React.createElement(Grid, { container: true },
                React.createElement(Grid, { item: true },
                    React.createElement(CircularProgress, { size: 50 })),
                React.createElement(Grid, { item: true, style: { zIndex: 1 } },
                    React.createElement(Typography
                    // variant='title' 
                    , { 
                        // variant='title' 
                        color: 'primary', style: { marginLeft: '15px' } }, this.props.message ? this.props.message : 'Loading...'))));
        }
    };
    // Render app DOM component
    MasterLoadingComponent.prototype.render = function () {
        return (React.createElement("div", { className: 'mLoading__loading' }, this.loadProgress()));
    };
    return MasterLoadingComponent;
}(Component));
export default MasterLoadingComponent;



//////////////////
// WEBPACK FOOTER
// ./src/components/masterLoading/MasterLoadingComponent.tsx
// module id = 212
// module chunks = 50